import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2728f648"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "光伏总览", -1))
const _hoisted_3 = { class: "info" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div", null, "收益"),
  /*#__PURE__*/_createElementVNode("div", null, "发电量")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "今日", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "--")
], -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" kwh ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "全部", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "--")
], -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" kwh ")

import { GetEssStationOverviewReply } from '@/types/common/station'


export default /*#__PURE__*/_defineComponent({
  props: {
    info: null
  },
  setup(__props: any) {

const props = __props as {
  info?: Partial<GetEssStationOverviewReply>
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", null, [
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", null, [
          _createElementVNode("span", null, _toDisplayString(props.info?.todaysGenEnergy?.toFixed(0) || 0), 1),
          _hoisted_7
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_8,
        _hoisted_9,
        _createElementVNode("div", null, [
          _createElementVNode("span", null, _toDisplayString(props.info?.totalGenEnergy?.toFixed(0) || 0), 1),
          _hoisted_10
        ])
      ])
    ])
  ]))
}
}

})